import { cx } from '@/utils/cx';
import { CrystalMark } from '@/assets/icons';
import { formatCurrency } from '@/utils/format';
import type { PremiumProduct } from '@/types/product';
import styles from './PremiumCard.module.scss';

export interface PremiumCardProps {
  product: PremiumProduct;
  onSelect: (product: PremiumProduct) => void;
  variant?: 'grid' | 'featured';
}

export function PremiumCard({ product, onSelect, variant = 'grid' }: PremiumCardProps) {
  const isBest = product.badge === 'best-value';

  return (
    <button
      type="button"
      className={cx(styles.row, isBest && styles.best, variant === 'featured' && styles.featured)}
      onClick={() => onSelect(product)}
    >
      <div className={styles.main}>
        <div className={styles.icon}>
          <CrystalMark size={19} />
        </div>
        <div>
          <div className={styles.title}>
            {product.title}
            {isBest && <span className={styles.badge}>Best value</span>}
          </div>
          {product.subtitle && <div className={styles.sub}>{product.subtitle}</div>}
        </div>
      </div>
      <div className={styles.price}>
        <div className={styles.priceAmount}>{formatCurrency(product.price, product.currency)}</div>
        <div className={styles.priceSub}>{formatCurrency(product.perMonthPrice, product.currency)}/mo</div>
      </div>
    </button>
  );
}
